(function () {
  var input = document.querySelector('[data-ctt-filter]');
  if (!input) return;
  var cards = Array.prototype.slice.call(document.querySelectorAll('[data-ctt-courses] [data-course-name]'));
  var count = document.querySelector('[data-ctt-count]');
  var empty = document.querySelector('[data-ctt-no-match]');
  function normalize(value) { return value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim(); }
  input.addEventListener('input', function () {
    var query = normalize(input.value), visible = 0;
    cards.forEach(function (card) {
      var matches = normalize(card.getAttribute('data-course-name')).indexOf(query) !== -1;
      card.hidden = !matches;
      if (matches) visible++;
    });
    count.textContent = String(visible);
    empty.hidden = visible !== 0;
  });
}());